module.exports = __webpack_public_path__ + "img/meter-bolt.cd1b17a4.svg";